import * as React from 'react';
import { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import ProductInventoryService, { ProductInventorySearchFilter } from '../../services/ProductInventoryService';
import ProductSearchResultFilters from './ProductSearchResultFilters';
import GenericSearchResults from '../../components/controls/GenericSearchResults';
import { ProductInventoryInfo } from '../../models/Product';
import ProductInventoryCardInfo from './ProductInventoryCardInfo';
import deepEqual from 'deep-equal';


function ProductSearchResult(props: { searchFilter: ProductInventorySearchFilter }) {

    const [fullFilter, setFullFilters] = useState<ProductInventorySearchFilter>();    

    useEffect(() => {

        if (props.searchFilter /*&& deepEqual(fullFilter, props.searchFilter)*/)
            setFullFilters(props.searchFilter);
    }, [props.searchFilter])

    if (!props.searchFilter)
        return null;

    return <Row>
        <Col lg={2}>
            <ProductSearchResultFilters searchFilter={props.searchFilter}
                onAtrributeFiltersChanged={(detailsFilters) => {
                    //console.log('detailsFilters', detailsFilters);
                    let newFullFilter: ProductInventorySearchFilter = { ...props.searchFilter };
                    newFullFilter.detailsFilters = detailsFilters;

                    // check equality
                    //const comparer = new ProductInventorySearchFilterComparer(fullFilter, newFullFilter);
                    if (!deepEqual(fullFilter, newFullFilter)) {
                        setFullFilters(newFullFilter);
                    }
                    else {

                        var different = false;

                        for (var i = 0; i < newFullFilter.detailsFilters.length; i++) {

                            const newFilt = newFullFilter.detailsFilters[i];
                            var currentFilterDetail = fullFilter.detailsFilters.find(x => x.AttributeId === newFilt.AttributeId);

                            if (deepEqual(newFilt.Codes, currentFilterDetail.Codes)) {
                                different = true;
                                break;
                            }
                        }

                        if (different) {
                            setFullFilters(newFullFilter);
                        }

                        //console.log('filters are equal full/newFullFilter', fullFilter, newFullFilter);
                    }
                }} />
        </Col>
        <Col lg={10}>
            {fullFilter && <GenericSearchResults<ProductInventoryInfo, ProductInventorySearchFilter>
                filter={fullFilter}
                listItemsPaged={(offset, filter) => { return ProductInventoryService.search(fullFilter, 8, offset); }}
                renderItemValues={x => <ProductInventoryCardInfo model={x} key={x.ProductNumber}
                    friendlySearchString={props.searchFilter.friendlySearchString} />}
                    renderBefore={(totalItems) => {
                        if (totalItems)
                            return (<div className="pb-2"><b>{new Intl.NumberFormat('en-US').format(totalItems)}</b><span className="small"> {totalItems > 1 ? 'products' : 'product'} found</span></div>)
                        return null
                }}
            />}
        </Col>
    </Row>
}

export default ProductSearchResult;
